import React from 'react';
import Button from '@material-ui/core/Button';
import { Html } from '../Html';
import { createIcon, runtime } from '../../common';

export const Card0 = ({ title, description, children, icon, className, iconClassName, headerClassName, tools, titleClassName, onClick }) => {
  let headerIcon = createIcon(icon, `c-icon-s2 mr-2 ${iconClassName}`);
  let props = onClick ? { onClick } : null;
  return (
    <div className={`jr-card p-0 c-radius ${className}`} {...props}>
      <div className={`jr-card-header c-radius-top mb-0 px-4 py-3 c-lb d-flex flex-row justify-content-between align-items-center ${headerClassName}`}>
        <div className="d-flex d-flex flex-row justify-content-start align-items-center">
          {headerIcon ? headerIcon : null}
          <h3 className={`card-heading c-text-s2 c-mb-0 c-ellipsis-1 ${titleClassName}`}>{title}</h3>
        </div>
        {tools ? <div className={`d-flex align-items-center `}>
          {tools}
        </div> : null}
      </div>
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

Card0.defaultProps = {
  className: '',
  iconClassName: '',
  titleClassName: '',
  headerClassName: 'bg-grey lighten-4'
}



export const Card1 = ({ color, icon, title, children, onClick, className, childrenClassName }) => {
  let props = onClick ? { onClick } : null;
  const extraClassName = runtime.mobile? "c-py-2 c-px-2" : "py-3 px-4";
  const titleClassName = runtime.mobile? "c-text-s1" : "c-text-s2";
  const iconClassName = runtime.mobile? "c-icon-s5" : "c-icon-s6";
  return (
    <div className={`jr-card jr-card-widget bg-${color} text-white card c-radius3 ${extraClassName} ${className}`} {...props}>
      <div className="media align-items-center flex-nowrap">
        <div className="mr-3">
          {createIcon(icon, iconClassName)}
        </div>
        <div className="media-body">
          <h1 className={`mb-0 text-white ${titleClassName}`}>{title}</h1>
          {children ? <div className={`d-flex flex-row justify-content-start align-items-end mt-1 mb-1 ${childrenClassName}`}>
            {children}
          </div> : null}
        </div>
      </div>
    </div>
  );
};

Card1.defaultProps = {
  className: '',
}